module.exports = __webpack_public_path__ + "img/home-07-cosmo-02-image-01.0dbf00e6.jpg";